import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import Navigation from "./navigation";
import {ContentType, PartMenuType} from "../constants";
import MobileNavigationBodyNew from './mobile/mobileNavigationBodyNew';
import ActionTypes from "../../../misc/actionTypes";
import SelectionMobileViewSwitchers from './mobile/selectionMobileViewSwitchers';
import FeatureWizard from "./featureWizard/featureWizard";
import Analytics from "../../../analytics";
import {BACKSPLASH_TYPES, COUNTERTOP_WIZARD_BUTTONS} from "../../kvComponent/core/constants";
import MobileParentNavigationItems from "./mobileParentNavigationItems";

import {getCurrentLayout} from "../../appLayout";
import BacksplashSelect from "../../selectionWindow/backsplashSelect";
import {getCommonVisualizerType, USE_NEW_CANVAS} from "../../../config";
import store from "../../../store";
import {setVisualizerCanvasPartId} from "../../../actions/navigationFunctions";
import LayoutNavigationItem from "../layoutNavigationItem";
import {getAvailableLayouts, getSideBarSubParts} from "./navUtils";

export default class MobileNavigationCommon extends Navigation {

  static propTypes = {
    changeMessageBoxState: PropTypes.func.isRequired,
    resetEverything: PropTypes.func.isRequired,
    goToMaterialsInfo: PropTypes.func,
    setCanvasClass: PropTypes.func,
    canvasId: PropTypes.string,
    userIsLoggedIn: PropTypes.bool,
    toggleUserPopup: PropTypes.func,
    setActiveFeature: PropTypes.func,
    activeFeature: PropTypes.object,
    fabricatorSettings: PropTypes.object,
    isPhoneNumberValidated: PropTypes.bool,
    setDemoPointClicked: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state.render = true;
    this.state.searchInputFocused = false;
  }

  componentDidMount() {
    $(document).on(ActionTypes.OPEN_MOBILE_NAVIGATION, this.openMobileMenu);
    $(document).on(ActionTypes.CHANGE_MOBILE_MENU_CONTENT_TYPE, (event, contentType) => {
      this.handleChangeContentType(contentType, true);
    });
    this.props.setNavigationViewType(4);
    this._componentDidMount();
  }

  // Keeps navigationState.visualizerCanvasPartId in step with whatever feature group the OPEN
  // mobile menu is showing, so the fullscreen docked canvas can frame it — the `qkb-visualizer`
  // slot's equivalent of what materialsWizardMain.js's setNewCanvasClass /
  // selectionMain.js's syncMaterialsCanvasClass already do for the embedded `qkb-materials` slot.
  // See visualizerNew/zoomToFeatureGroup/useZoomToActiveFeatureGroup.ts for the consumer.
  //
  // Cheap to call on every update: syncVisualizerCanvasPartId dedupes by value, so a dispatch
  // only happens when the active feature GROUP actually changes — not on every re-render, and not
  // when clicking different products inside the same group.
  componentDidUpdate() {
    this.syncVisualizerCanvasPartId();
  }

  // The feature group the canvas should frame: the selected sub part if there is one, otherwise
  // the selected parent category (which is itself a feature group for PartMenuType.Simple parts;
  // for a Complex parent with no sub part picked yet, layout.getFeatureGroupByPartId() simply
  // finds nothing and the consumer falls back to idle framing).
  getVisualizerZoomingPartId = () => {
    if (!this.state.showNavigation) {
      return null;
    }
    const navigationItem = this.state.childNavigationItem || this.state.parentNavigationItem;
    const part = navigationItem && navigationItem.part;
    return (part && part.partId) || null;
  };

  syncVisualizerCanvasPartId = () => {
    if (!USE_NEW_CANVAS) {
      return;
    }
    const partId = this.getVisualizerZoomingPartId();
    // Nothing to frame — either the menu is closed or no category is picked yet. Deliberately
    // leave the previous value in place rather than clearing it: clearing would re-run the
    // consumer and animate the canvas back to its idle framing on every menu close, throwing away
    // both the feature framing and any manual panning the user did afterwards. Not moving at all
    // is the correct "menu closed" behavior.
    if (!partId || partId === this._lastVisualizerCanvasPartId) {
      return;
    }
    this._lastVisualizerCanvasPartId = partId;
    store.dispatch(setVisualizerCanvasPartId(partId));
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const layout = getCurrentLayout();
    if (!this.state.designNavigationItems || !this.state.designNavigationItems.length) {
      this.setState({designNavigationItems: layout.designNavigationItems()});
    }
    if (nextProps.filterGroups.length) {
      let updateComponent = false;
      if (nextProps.filterGroups.length === this.props.filterGroups.length) {
        updateComponent = nextProps.filterGroups.some((filter, index) => {
          return filter.filterId !== this.props.filterGroups[index].filterId
            || filter.filterGroupId !== this.props.filterGroups[index].filterGroupId
        });
      }
      if (updateComponent) {
        this.reRenderComponent();
      }
    }
    if (nextProps.activeNavigationFilter !== this.props.activeNavigationFilter
      && COUNTERTOP_WIZARD_BUTTONS.some(btn => btn.buttonId === nextProps.activeNavigationFilter)) {
      if (this.state.parentNavigationItem && (
        this.state.parentNavigationItem.part.partName === "Countertop"
        || this.state.parentNavigationItem.part.partName === "CenterIsland"
      )) {
        const subParts = this.state.parentNavigationItem.part.subParts();
        let subPart = null;
        switch (nextProps.activeNavigationFilter) {
          case COUNTERTOP_WIZARD_BUTTONS[0].buttonId:
          case COUNTERTOP_WIZARD_BUTTONS[1].buttonId:
          case COUNTERTOP_WIZARD_BUTTONS[2].buttonId:
            subPart = (this.state.parentNavigationItem.part.partName === "Countertop")
              ? subParts.find(sPart => sPart.part.partId === "countertop")
              : subParts.find(sPart => sPart.part.partId === "center_island_countertop");
            break;
          case COUNTERTOP_WIZARD_BUTTONS[4].buttonId:
            subPart = (this.state.parentNavigationItem.part.partName === "Countertop")
              ? subParts.find(sPart => sPart.part.partId === "countertop")
              : subParts.find(sPart => sPart.part.partId === "center_island_countertop");
            break;
          case COUNTERTOP_WIZARD_BUTTONS[3].buttonId:
            subPart = (this.state.parentNavigationItem.part.partName === "Countertop")
              ? subParts.find(sPart => sPart.part.partId === "edge_profile")
              : subParts.find(sPart => sPart.part.partId === "center_island_edge");
            break;
        }
        if (subPart) {
          this.handleSubPartClick(subPart, nextProps.activeNavigationFilter)
        }
      }
    }
    this._UNSAFE_componentWillReceiveProps(nextProps)
  }

  reRenderComponent = () => {
    this.setState({
      render: false
    }, () => {
      this.setState({
        render: true
      })
    })
  };

  parentCategoryClick = (parentItemText) => {
    const clickedParent = this.state.designNavigationItems.find(item => item.text === parentItemText);
    if (clickedParent.part.menuType === PartMenuType.Simple) {
      this.triggerOpenNavigationMenu(clickedParent.text);
    } else {
      const firstChild = getSideBarSubParts(clickedParent.part)[0];
      if (firstChild) {
        this.triggerOpenNavigationMenu(firstChild.text, clickedParent.text);
      }
    }
    if (parentItemText === "Floor") {
      $('html, body').animate({scrollTop: document.body.scrollHeight}, 800);
    } else if (parentItemText === "Ceiling") {
      $('html, body').animate({scrollTop: 0}, 800);
    }
  };

  openMobileMenu = () => {
    // $(window).trigger(ActionTypes.SET_CANVAS_SCALE);
    this.setState({
      showNavigation: true,
      contentType: ContentType.Design,
      contextMenuOpen: false,
      hoveredLayer: {}
    }, () => {
      this.menuOpened();
      setTimeout(() => {
        $(document).on('click', this.handleWrapperBlur);
        window.mobileMenuOpened = true;
        $(window).trigger(ActionTypes.DISABLE_PINCH_ZOOM);
        document.removeEventListener('click', this.handleContextMenuBlur);
      }, 0)
    });
  };

  scrollContentToTop = () => {
    const listContainer = document.querySelector('.menu-body__content');
    if (listContainer) {
      listContainer.scrollTop = 0;
    }
  };

  handleWrapperBlur = (e) => {
    const navClick = e.target.closest('[class*="menu"]');
    const messageBoxClick = e.target.closest('[class*="message"]');
    const lockClick = e.target.closest('[class*="lock"]');
    const userPopupClick = e.target.closest('[class*="user-popup"]');
    const twoFactorPopup = e.target.closest('[class*="TwoFactorAuth-popup"]');
    const countryList = e.target.closest('[class*="country"]');
    const searchClick = e.target.closest('[class*="search"]');
    const wizardClick = e.target.closest('[class*="wiz"]');
    const loadingClick = e.target.closest('[class*="full-screen-wrapper"]');
    if (!navClick && !messageBoxClick && !searchClick && !lockClick && !userPopupClick && !twoFactorPopup
      && !countryList && !loadingClick && !window.touchMove
      && !wizardClick && !window.canvasIsDragging && document.body.classList.contains('body--bv')) {
      this.closeNavigation();
    }
  };

  closeNavigation = () => {
    if (!window.canvasIsDragging) {
      this.props.setCanvasClass('none', true);
    }
    this.setState({
      showNavigation: false,
      showFilterSelection: false,
      showerWallWizardGroupsSelected: true,
    }, () => {
      setTimeout(() => {
        this.setState({
          contentType: ContentType.None,
          searchText: "",
          showFilterSelection: true,
          showerWallWizardGroupsSelected: false,
        });
        this.props.setActiveFeature(null);
        // this.resetWizardSteps();  // after wizard unmounts
      }, 500);
      $(document).off('click', this.handleWrapperBlur);
      window.mobileMenuOpened = false;
      $(window).trigger(ActionTypes.ENABLE_PINCH_ZOOM);
    });
  };

  handleContextMenuBlur = (e) => {
    const navClick = e.target.closest('[class*="contextmenu"]');
    // console.log('blur');
    if (!navClick && !window.touchMove) {
      this.setState({
        contextMenuOpen: false,
        hoveredLayer: {}
      }, () => {
        document.removeEventListener('click', this.handleContextMenuBlur);
      });
    }
  };

  handleChangeContentType = (contentType, resetNav = false) => {
    this.setState({
      contentType,
      parentNavigationItem: resetNav ? null : this.state.parentNavigationItem,
      childNavigationItem: resetNav ? null : this.state.childNavigationItem,
  });
    if (contentType === ContentType.Design) {
      this.setNewActiveFeature();
    }
  };

  /* start oldNav methods */

  scrollToDefault = (item) => {
    if (!window.canvasIsDragging) {
      this.props.setCanvasClass(item.text.toLowerCase().replace(/ /g, "-"));
    }
    this.scrollContentToTop();
  };

  /* end oldNav methods */

  resetEverything = () => {
    this.props.resetEverything();
    this.closeNavigation();
    setTimeout(() => {
      this.resetWizardSteps();  // after wizard unmounts
    }, 300)
  };

  menuOpened = () => {
    this.scrollContentToTop();
    this.setNewActiveFeature();
    this._menuOpened();
  };

  handleContextMenuClick = (menuItem) => {
    const layout = getCurrentLayout();
    if (!this.state.showNavigation) {

      let clickedParent = "", clickedButton = "";
      const isBacksplash = BACKSPLASH_TYPES.some(bType => bType === menuItem.text);

      if (menuItem.text === "Edge Profile") {
        if (this.props.setActiveNavigationFilter) {
          this.props.setActiveNavigationFilter(COUNTERTOP_WIZARD_BUTTONS[3].buttonId);  // set active navigation filter
          this.props.setActiveNavigationFilterStepIndex(3);
        }
      } else if (isBacksplash) {
        const wallsParent = layout.parts["Walls"];
        const backsplashSubPart = wallsParent.subParts().find(subPart => subPart.part.partId === "backsplash");
        this.checkIfAllFeaturesReceived(backsplashSubPart);
        const featureToClick = backsplashSubPart.part.getFeatureByBacksplashType(menuItem.text);
        // console.log("featureToClick", featureToClick);
        if (featureToClick) {
          featureToClick.handleClick();
        }
        clickedParent = "Walls";
        clickedButton = "Backsplash";

        if (this.props.setActiveNavigationFilter) {
          this.props.setActiveNavigationFilter(COUNTERTOP_WIZARD_BUTTONS[4].buttonId);  // set active navigation filter
          this.props.setActiveNavigationFilterStepIndex(4);
        }

      }
      if (!isBacksplash) {
        clickedButton = menuItem.text;
        clickedParent = menuItem.subMenuParent || this.state.contextMenuOpen;
      }

      if (clickedParent && clickedParent.module) {
        clickedParent = "Cabinet"
      }

      if (!window.canvasIsDragging) {
        this.props.setCanvasClass(clickedParent.toLowerCase().replace(/ /g, "-"));
      }

      if (clickedParent === "Walls" && (clickedButton === "Left Shower Wall" || clickedButton === "Pony Wall")) {
        this.ponyWallAndLeftWallClick(menuItem);
      }

      this.setState({
        showNavigation: true,
        contentType: ContentType.Design,
        contextMenuOpen: false,
        hoveredLayer: {}
      }, () => {
        this.menuOpened();
        this.triggerOpenNavigationMenu(clickedButton, clickedParent);
        $(document).on('click', this.handleWrapperBlur);
        window.mobileMenuOpened = true;
        $(window).trigger(ActionTypes.DISABLE_PINCH_ZOOM);
        $(document).off('click', this.handleContextMenuBlur);
        if (menuItem.clickFeature && !isBacksplash) {
          const featureToClick = menuItem.part.features.find(feature => feature.partName === menuItem.subMenuText);
          if (featureToClick) {
            featureToClick.handleClick();
          }
        }
      });
    }

  };

  getDisplayRoomContent = () => {
    let presets = this.checkedForLockedPresets();
    return (
      <div className={"menu-layout" + (!presets.length ? " menu-layout--empty" : "")}>
        {presets.length ? (
          <ul className="menu-layout__list">
            {presets.map((preset, index) => ( //
              <li className={"menu-layout__list-item"
              + (this.state.activeDefaultPreset === index ? " menu-layout__list-item--active" : "")}
                  onClick={() => Analytics.sendClickEvent("default-preset-clicked-" + index) && this.handleDefaultPresetClick(index, preset.presetIsLocked)}
                  key={index}>
                <div className={"menu-layout__list-item-image"
                + (preset.presetIsLocked ? " menu-layout__list-item-image--locked" : "")}>
                  <img src={preset.bv_screen} alt="item.type"/>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="menu-layout__text">No display room found</p>
        )}
      </div>
    )
  };

  contentDesignWizard = () => {
    const wizardGroups = this.getWizardGroupsForPartId(this.state.childNavigationItem.part.partId);
    return (
      <FeatureWizard
        features={this.state.childNavigationItem.part.features}
        exitFeatureWizard={this.exitFeatureWizard}
        getFilterDisplayName={this.getFilterDisplayName}
        wizardGroups={wizardGroups}
        wizardStepIndex={this.state.wizardStepIndex}
        handleNavigationItemClick={this.handleNavigationItemClick}
        isMobile={true}
        setWizardGroups={this.setWizardGroups}
        setWizardLockedItem={this.setWizardLockedItem}
        changeMessageBoxState={this.props.changeMessageBoxState}
        isPhoneNumberValidated={this.props.isPhoneNumberValidated}
        userIsLoggedIn={this.props.userIsLoggedIn}
        toggleUserPopup={this.props.toggleUserPopup}
        activeSubPart={this.state.childNavigationItem.part}
        showerWallWizardGroupsSelected={this.state.showerWallWizardGroupsSelected}
        toggleWizardFilterSelection={this.toggleWizardFilterSelection}
        handleSearchInputChange={this.handleSearchInputChange}
        searchText={this.state.searchText}
        // activePart={this.state.parentNavigationItem.part}
        // activeSubPart={this.state.childNavigationItem.part}
        // toggleApplyWallsCheckbox={this.toggleApplyWallsCheckbox}
        // isWallItem={this.isWallItem}
        // handleSubTypeClick={this.handleSubTypeClick}
        // wizardStepIndex={this.state.wizardStepIndex}
      />
    )
  };

  toggleSearchInputFocus = () => {
    this.setState({
      searchInputFocused: !this.state.searchInputFocused
    })
  };

  getFeatures = (layout) => {
    const parentItem = this.state.parentNavigationItem;
    const childItem = this.state.childNavigationItem;
    const currentParent = (parentItem && (parentItem.part.menuType === PartMenuType.Simple)) ? parentItem : childItem;
    if (!currentParent) {
      return []
    }
    let features = layout.designNavigationItems(currentParent, this.props.selectedFilters, this.state.searchText);
    return features
  };

  contentBody = (features, useWizard, useFilters, activePart, activeSubPart, filterSelectionHasValues, allFeaturesReceived) => {
    const {intl} = this.props;
    const layout = getCurrentLayout();
    const layoutNames = getAvailableLayouts();
    return (
      <div className={"menu-body"
      + ((this.state.contentType === ContentType.Design && !this.state.parentNavigationItem)
      || this.state.contentType === ContentType.DisplayRoom ? " menu-body--full" : "")
      + (useWizard || (useFilters && filterSelectionHasValues) ? " menu-body--wizard" : "")
      + (this.state.contentType === ContentType.Layout ? " menu-body--layout" : "")
      }>
        {this.state.contentType === ContentType.Design && activePart ? (
          <div className="menu-body__top">
            <SelectionMobileViewSwitchers switchers={[2,4]}/>
            {activeSubPart && activeSubPart.partId === "backsplash" && getCommonVisualizerType() === "kitchen" ? (
              <div className="menu-body__top-select">
                <BacksplashSelect updateParent={this.backsplashSelectClick}/>
              </div>
            ) : null}
            <div className="menu-body__top-subtypes">
              {activePart.menuType === PartMenuType.Complex && activePart.subTypes().length
                ? activePart.subTypes().map(subType => (
                  <button className={"menu-body__top-subtypes-button"
                  + (activePart.activeSubType() === subType ? " menu-body__top-subtypes-button--active" : "")}
                          onClick={() => this.handleSubTypeClick(subType)}
                          key={subType}>
                    {activePart.subTypeToString(subType) || subType}
                  </button>
                )) : (
                  <input className={"search-input"
                  + (this.state.searchText ? " search-input--no-icon" : "")
                  + (this.state.searchText && this.state.searchText.length > 12 ? " search-input--with-close" : "")
                  }
                         value={this.state.searchText}
                         onFocus={this.toggleSearchInputFocus}
                         onBlur={this.toggleSearchInputFocus}
                         onChange={this.handleSearchInputChange}
                         placeholder={intl.formatMessage({id: "mobileMenu.searchPlaceholder"})}
                         id="main-search"
                  />
                )}
              {this.state.searchText
                ? <button className={"ui-close search-close"}
                          onClick={() => this.handleSearchInputChange({target: {value: ""}})}/>
                : null}
            </div>
          </div>
        ) : null}
        <div
          className={"menu-body__content" + (this.props.filtersVisible ? " menu-body__content--filtersVisible" : "")}>
          {this.state.contentType === ContentType.Layout ? (
            <div className="menu-layout">
              <ul className="menu-layout__list">
                {layoutNames.map(key => {
                  return <LayoutNavigationItem layout={layout}
                                               key={key}
                                               keyType={key}
                                               isMobile={true}
                                               handleLayoutItemClick={this.handleLayoutItemClick}/>
                })}
              </ul>
            </div>
          ) : null}
          {this.state.contentType === ContentType.Design ? (
            <div className="menu-design">
              {this.state.parentNavigationItem ? (
                this.state.render ? (
                  <MobileNavigationBodyNew features={features}
                                           showNavigation={this.state.showNavigation}
                                           parentItem={this.state.parentNavigationItem}
                                           childItem={this.state.childNavigationItem}
                                           onItemClick={this.handleNavigationItemClick}
                                           userIsLoggedIn={this.props.userIsLoggedIn}
                                           toggleUserPopup={this.props.toggleUserPopup}
                                           activeFeature={this.props.activeFeature}
                                           isPhoneNumberValidated={this.props.isPhoneNumberValidated}
                                           searchText={this.state.searchText}
                                           refreshCB={this.props.refreshCB}
                                           layoutName={layout.getCurrentLayoutName()}
                                           existInQtCategory={layout.qtCategories ? activeSubPart && activeSubPart.existInQtCategory : true}
                                           allFeaturesReceived={allFeaturesReceived}
                                           parentUpdate={this.updateComponent}
                  />
                ) : <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
              ) : <MobileParentNavigationItems onItemClick={this.parentCategoryClick}/>}
            </div>
          ) : null}
          {this.state.contentType === ContentType.DisplayRoom ? this.getDisplayRoomContent() : null}
          {this.state.contentType === ContentType.Loading ? (
            <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
          ) : null}
        </div>
      </div>
    )
  };

}
